import { render } from "./apptitude-table.vue?vue&type=template&id=62de8aed"
import script from "./apptitude-table.vue?vue&type=script&lang=js"
export * from "./apptitude-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__